<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../assets/images/banner3.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon3">
          <i class="iconfont icon-pinpaizichanpingtai"></i>
        </div>
        <div class="breadcrumb_item">物流&订单管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">出库管理</div>
      </div>

      <div class="main_content">
        <div class="tit">配货</div>
        <!-- <div class="block">
          <h1>订单ID</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.orderid"
              placeholder="请输入订单ID"
            />
          </div>
        </div> -->
        <!-- <div class="block">
          <h1>商品ID</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.cmid"
              placeholder="请输入商品ID"
            />
          </div>
        </div> -->
        <!-- <div class="block">
          <h1>商品名称</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.order_goods"
              placeholder="请输入商品名称"
            />
          </div>
        </div> -->
        <div class="block">
          <h1>库源信息</h1>
          <div class="input_box flex-between" @click="handleWarehouseShow(5)">
            <van-field
              v-model="warehouseStr"
              placeholder="请选择库源信息"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div
            class="input_box flex-between"
            @click="handleWarehouseShow(1)"
            v-if="false"
          >
            <van-field
              v-model="warehouseOneName"
              placeholder="请选择仓库名称"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div
            class="input_box flex-between"
            @click="handleWarehouseShow(2)"
            v-if="false"
          >
            <van-field
              v-model="warehouseTwoName"
              placeholder="请选择货架名称"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div
            class="input_box flex-between"
            @click="handleWarehouseShow(3)"
            v-if="false"
          >
            <van-field
              v-model="warehouseThreeName"
              placeholder="请选择层名称"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div
            class="input_box flex-between"
            @click="handleWarehouseShow(4)"
            v-if="false"
          >
            <van-field
              v-model="warehouseFourName"
              placeholder="请选择货位名称"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>
        <div class="block">
          <h1>商品信息：</h1>
          <div class="content">
            <p>商品名称：{{ orderShopItem.cmname }}</p>
            <!-- <p>商品ID：{{ orderShopItem.id }}</p> -->
            <p>SKU：{{ orderShopItem.sku }}</p>
             <p>{{orderShopItem.attr}}</p>
            <!-- <div
              v-for="(label, labelIndex) in orderShopItem.attr"
              :key="labelIndex"
            >
              <p>
                <span>{{ label | formatAttr }}</span>
              </p>
            </div> -->
            <p>商品所属企业：{{ orderShopItem.qyguidstr }}</p>
            <p>配货所需数量：{{ orderShopItem.cmnum }}</p>
          </div>
        </div>
        <!-- <div class="block">
          <h1>cmnum</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.cmnum"
              placeholder="请输入cmnum"
            />
          </div>
        </div> -->
      </div>

      <div
        class="primary-button"
        :class="orderShopItem.warehouse != '' ? 'disable' : ''"
        @click="query"
      >
        保存确认
      </div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup
      v-model="isShow"
      round
      position="bottom"
      class="brandPopup custom_picker"
      :style="{ height: '50%' }"
    >
      <div class="block" v-if="isShowType == 1">
        <van-picker
          title="请选择仓库名称"
          show-toolbar
          :columns="warehouseOneColumn"
          value-key="whname"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-else-if="isShowType == 2">
        <van-picker
          title="请选择货架名称"
          show-toolbar
          :columns="warehouseTwoColumn"
          value-key="whname"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-else-if="isShowType == 3">
        <van-picker
          title="请选择层名称"
          show-toolbar
          :columns="warehouseThreeColumn"
          value-key="whname"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-else-if="isShowType == 4">
        <van-picker
          title="请选择货位名称"
          show-toolbar
          :columns="warehouseFourColumn"
          value-key="whname"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-else-if="isShowType == 5">
        <van-picker
          title="请选择库源信息"
          show-toolbar
          :columns="shopWarehouseColumn"
          value-key="msg"
          item-height="65px"
          @confirm="onConfirm"
          @cancel="isShow = false"
        >
          <template #option="option">
            <div class="custom-option">
              {{ option.newMsg }}
            </div>
          </template>
        </van-picker>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getWearhouseList, encryptstringview } from "../../api/api";
import {
  getLogisticsDisDetail,
  addLogisticsDis,
  editLogisticsDis,
  getShopWarehouse,
} from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDistribution",
  data() {
    return {
      isShowType: 1,
      isShow: false,
      columns: [],
      formData: {
        id: "",
        warehouse: "",
      },
      warehouseName: "",
      qyid: "",

      shopWarehouseColumn: [], // 商品库源信息
      warehouseStr: "",

      warehouseOneColumn: [],
      warehouseOneId: "",
      warehouseOneName: "",

      warehouseTwoColumn: [],
      warehouseTwoId: "",
      warehouseTwoName: "",

      warehouseThreeColumn: [],
      warehouseThreeId: "",
      warehouseThreeName: "",

      warehouseFourColumn: [],
      warehouseFourId: "",
      warehouseFourName: "",

      orderShopItem: "", // 配货详情
    };
  },
  filters: {
    formatAttr(date) {
      if (date.indexOf("；") != -1) {
        let splitArr = date.split("；");
        let str1 = "属性标签：" + splitArr[0];
        let str2 = "属性标签值：" + splitArr[1];
        return str1 + "；" + str2;
      } else {
        let str = "属性标签：" + date;
        return str;
      }
      // let splitArr = date.indexOf('；') != -1 ? date.split('；') : date
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, wsid } = JSON.parse(res.jsondata);
        this.wsid = wsid;
        if (id != 0) {
          this.formData.id = id;
          this.getLogisticsDisDetail(id);
        } else {
          this.formData.id = "";
        }
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getLogisticsDisDetail(id) {
      getLogisticsDisDetail({ id }).then((res) => {
        res.attr = res.attr != "" ? JSON.parse(res.attr) : [];
        this.orderShopItem = res;
        this.formData.id = res.id;
        this.formData.warehouse = res.warehouse;
        this.warehouseStr = res.msg;
        // this.getWearhouseList(v.warehouse);
        this.getShopWarehouse(res.cmid);
      });
    },

    // 获取商品库源信息
    getShopWarehouse(cmid) {
      let { orderShopItem } = this;
      // 商品属性标签进行分解
      // const modifiedArray = orderShopItem.attr.map((item) =>
      //   item.replace("；", ";")
      // );
      getShopWarehouse({ cmid }).then((res) => {
        res.forEach((v) => {
          v.newMsg =
            v.attr +
            " | " +
            "库源数量：" +
            v.num +
            " | " +
            "仓库：" +
            v.whid1str +
            " | " +
            "货架：" +
            v.whid2str +
            " | " +
            "层：" +
            v.whid3str +
            " | " +
            "货位：" +
            v.whid4str;
        });

        // 过滤当前商品相同的属性
        const filterArr = res.filter(
            (obj) => obj.attr === JSON.stringify(orderShopItem.attr)
        );
        this.shopWarehouseColumn = filterArr;
      });
    },

    // 获取仓库列表
    getWearhouseList() {
      let params = {
        openid: this.$store.state.OPENID,
        qyid: this.qyid,
      };
      getWearhouseList(params).then((res) => {
        this.warehouseOneColumn = res;
      });
    },

    // 选择仓库
    handleWarehouseOne(e) {
      console.log(e, "====e");
      let { warehouseOneColumn } = this;
      warehouseOneColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseTwoColumn = v.childs2;
          this.warehouseThreeColumn = [];
          this.warehouseFourColumn = [];
          this.warehouseTwoId = "";
          this.warehouseTwoName = "";
          this.warehouseThreeId = "";
          this.warehouseThreeName = "";
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },
    // 选择货架
    handleWarehouseTwo(e) {
      let { warehouseTwoColumn } = this;
      warehouseTwoColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseThreeColumn = v.childs3;
          this.warehouseFourColumn = [];
          this.warehouseThreeId = "";
          this.warehouseThreeName = "";
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },
    // 选择层
    handleWarehouseThree(e) {
      let { warehouseThreeColumn } = this;
      warehouseThreeColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseFourColumn = v.childs4;
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },

    // 显示弹窗
    handleWarehouseShow(e) {
      this.getWearhouseList();
      this.isShowType = e;
      this.isShow = true;
    },

    onConfirm(e) {
      let { isShowType } = this;
      if (isShowType == 1) {
        this.warehouseOneId = e.id;
        this.warehouseOneName = e.whname;
        this.warehouseTwoColumn = e.childs2;
        this.warehouseThreeColumn = [];
        this.warehouseFourColumn = [];
        this.warehouseTwoId = "";
        this.warehouseTwoName = "";
        this.warehouseThreeId = "";
        this.warehouseThreeName = "";
        this.warehouseFourId = "";
        this.warehouseFourName = "";
      } else if (isShowType == 2) {
        this.warehouseTwoId = e.id;
        this.warehouseTwoName = e.whname;
        this.warehouseThreeColumn = e.childs3;
        this.warehouseFourColumn = [];
        this.warehouseThreeId = "";
        this.warehouseThreeName = "";
        this.warehouseFourId = "";
        this.warehouseFourName = "";
      } else if (isShowType == 3) {
        this.warehouseThreeId = e.id;
        this.warehouseThreeName = e.whname;
        this.warehouseFourColumn = e.childs4;

        this.warehouseFourId = "";
        this.warehouseFourName = "";
      } else if (isShowType == 4) {
        this.warehouseFourId = e.id;
        this.warehouseFourName = e.whname;
      } else if (isShowType == 5) {
        this.formData.warehouse = e.id;
        this.warehouseStr = e.msg;
      }

      this.isShow = false;
    },

    // 保存
    query() {
      if (this.orderShopItem.warehouse != "") {
        return;
      }
      let { formData } = this;
      if (formData.warehouse == "") {
        this.$toast("请选择货源信息");
        return;
      }
      if (formData.id == "") {
        this.addLogisticsDis();
      } else {
        this.editLogisticsDis();
      }
    },
    // 添加数据
    addLogisticsDis() {
      let { formData } = this;
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addLogisticsDis(formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 修改数据
    editLogisticsDis() {
      let { formData } = this;
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editLogisticsDis(formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .content {
        p {
          font-size: 24px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .brandPopup {
    /deep/ .van-ellipsis {
      white-space: normal !important;
    }
  }
  .van-ellipsis {
    background: #ff0012 !important;
  }
  .primary-button {
    &.disable {
      background: #a6a6a6;
    }
  }
}
</style>